import formInputsTypes from 'constants/simulatorData/simulatorConstant';
import Basculante from 'assets/img/porte-basculante.png';
import Enroulable from 'assets/img/porte-enroulable.png';
import Sectionnelle from 'assets/img/porte-sectionnelle.png';

import { cableLongueur } from './cables';
import { typeRessort } from './ressorts';
import { panneauLargeur, panneauPosition } from './panneaux';
import { galetType } from './galets';
import { kitMotorisationType } from './motorisation';
import { hauteur, typeManoeuvre } from './complet';
import Ressorts from 'assets/img/ressort-torsion.png';
import Moteur from 'assets/img/kit-motorisation-porte.png';
import Galets from 'assets/img/galets.png';
import Cables from 'assets/img/cables.png';
import Porte from 'assets/img/porte.png';
import Panneau from 'assets/img/panneau.png';

// ---------- TORSION FLOW ----------
const prestationImages = {
	Câbles: Cables,
	Ressorts: Ressorts,
	'Galets / roulettes': Galets,
	'Panneaux / lames': Panneau,
	'Kit Motorisation': Moteur,
	'Porte de garage complet': Porte,
};

const prestation = {
	id: 'PG-PREST',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'prestation',
	className: 'col-6',
	label: 'Sélectionner une prestation',
	nextStepData: false,

	fetchData: (currentFormValue, fnSuccess) => {
		const doorType =
			currentFormValue?.Type?.value ||
			currentFormValue?.values?.Type?.value ||
			currentFormValue?.typePorte?.value ||
			currentFormValue?.typePorte?.label;

		const makeDesc = (presta) => {
			if (presta === 'Câbles') {
				return (
					`Fourniture de câbles pour porte de garage ${doorType || ''}\n` +
					`Câbles acier galvanisé compatibles avec le système de levage.`
				);
			}

			if (presta === 'Galets / roulettes') {
				return (
					`Fourniture de galets/roulettes pour porte de garage sectionnelle\n` +
					`Pièces de guidage compatibles avec les rails existants.`
				);
			}

			if (presta === 'Panneaux / lames') {
				if (doorType === 'Enroulable') {
					return (
						`Fourniture de lames 77 pour porte de garage enroulable\n` +
						`Lames aluminium laquées compatibles avec l’enroulement dans le coffre.`
					);
				}
				return (
					`Fourniture de panneaux pour porte de garage sectionnelle.\n` +
					`Panneaux articulés conçus pour s’adapter à la structure existante, assurant une continuité esthétique et un fonctionnement optimal de la porte.`
				);
			}

			if (presta === 'Porte de garage complet') {
				if (doorType === 'Enroulable') {
					return (
						`Fourniture d’une porte de garage complète enroulable.\n` +
						`Porte équipée de lames aluminium de 77 mm, conçue sur mesure selon les dimensions de la baie et adaptée à l’usage du garage.`
					);
				}

				return (
					`Fourniture d’une porte de garage complète ${doorType || ''}.\n` +
					`Porte neuve réalisée sur mesure, adaptée aux dimensions de l’ouverture et aux contraintes d’utilisation.`
				);
			}

			return '';
		};

		const allowedByType = {
			Basculante: ['Câbles', 'Ressorts', 'Kit Motorisation', 'Porte de garage complet'],
			Sectionnelle: [
				'Câbles',
				'Ressorts',
				'Galets / roulettes',
				'Panneaux / lames',
				'Kit Motorisation',
				'Porte de garage complet',
			],
			Enroulable: ['Panneaux / lames', 'Kit Motorisation', 'Porte de garage complet'],
		};

		const allowed = allowedByType[doorType] || allowedByType.Sectionnelle;

		const getNextStep = (presta) => {
			// For testing routing:
			if (presta === 'Ressorts') return typeRessort;

			if (presta === 'Câbles') return cableLongueur;

			if (presta === 'Galets / roulettes') return galetType;

			// dimensions required
			if (presta === 'Panneaux / lames') return panneauLargeur;

			// motorisation => default electric manoeuvre
			if (presta === 'Kit Motorisation') return kitMotorisationType;
			if (presta === 'Porte de garage complet') return typeManoeuvre;
			return false;
			// by default ask manoeuvre
		};

		const options = allowed.map((p) => ({
			id: p,
			label: p,
			value: p,
			nextStep: getNextStep(p),
			description: makeDesc(p),
			imageUrl: prestationImages[p],
		}));

		// Optional: if Enroulable, you may want to default manoeuvre to Electrique elsewhere too
		fnSuccess(options);
	},
};

const PorteGarageData = {
	id: 'VR-TI',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type porte de garage',
	name: 'Type',
	className: 'col-12',
	classGroup: 'Type',
	nextStepData: prestation,
	options: [
		{
			id: 'Basculante',
			label: 'Basculante',
			value: 'Basculante',
			imageUrl: Basculante,
		},
		{
			id: 'Sectionnelle',
			label: 'Sectionnelle',
			imageUrl: Sectionnelle,
			value: 'Sectionnelle',
		},
		{
			id: 'Enroulable',
			label: 'Enroulable',
			value: 'Enroulable',
			imageUrl: Enroulable,
		},
	],
};

export default PorteGarageData;
